export default {
    title: 'History / Financials',
    panelTitle: 'Sessions & Financials',
    balance: 'Balance',
    futureTab: 'Upcoming',
    pastTab: 'Completed',
    owedTab: 'Owed',
    remainders: 'Remainders',
    noRemainders: 'No open remainders.',
    created: 'Created',
    showMore: 'Show more ({count})',
    markUnpaid: 'Not paid',
    closedRemainders: 'Closed remainders',
    session: 'Session',
    markPaid: 'Paid',
    recordPayment: 'Record payment',
    settle: 'Settle',
    deleteEntry: 'Delete',
    reopen: 'Reopen',
    undoPayment: 'Undo',
    addRemainder: 'New remainder',
    amountLabel: 'Amount (€)',
    notesPlaceholder: 'Notes (optional)',
    submitRemainder: 'Add',
    paymentRecorded: 'Payment recorded',
    remainderNotice: 'A remainder of {amount} € will be created',
    methods: {
        cash: 'Cash',
        card: 'Card',
        transfer: 'Bank transfer',
    },
}
